import { differenceInCalendarDays, isValid, parseISO } from 'date-fns';
import { memo } from 'react';

interface DaysToStartProps {
  startingDate: string;
}

export const DaysToStart = memo(({ startingDate }: DaysToStartProps) => {
  if (!startingDate) return null;
  const start = parseISO(startingDate);
  if (!isValid(start)) return null;
  const diff = differenceInCalendarDays(start, new Date());
  if (diff <= 0) return null;
  return (
    <span className="status-vigencia">
      {diff === 1 ? (
        <span>
          Falta <b>{diff}</b> dia para iniciar
        </span>
      ) : (
        <span>
          Faltam <b>{diff}</b> dias para iniciar
        </span>
      )}
    </span>
  );
});
